import { DoqFace, DoqSize, DoqType } from '@ardoq/doq';
import styled from 'styled-components';
import { Button, ButtonType } from '@ardoq/button';
import { Header1, Paragraph } from '@ardoq/typography';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName } from '@ardoq/icons';
import React from 'react';
import { FlexBox, Stack } from '@ardoq/layout';

type DataSourceEmptyTableProps = {
  title: string;
  message: React.ReactNode;
  button?: {
    text: string;
    onClick: () => void;
    icon?: IconName;
  };
};

export const DataSourceEmptyTable = ({
  title,
  message,
  button,
}: DataSourceEmptyTableProps) => {
  return (
    <Container>
      <DoqFace doqType={DoqType.EMPTY_BOX} doqSize={DoqSize.PETIT_MEDIUM} />
      <Stack gap="medium">
        <Header1>{title}</Header1>
        <Paragraph variant="text1">{message}</Paragraph>
        {button && (
          <FlexBox>
            <Button onClick={button.onClick} buttonType={ButtonType.PRIMARY}>
              {button.icon && <Icon iconName={button.icon} />}
              {button.text}
            </Button>
          </FlexBox>
        )}
      </Stack>
    </Container>
  );
};

const Container = styled(FlexBox).attrs({
  align: 'center',
  justify: 'center',
  gap: 'medium',
})`
  min-height: 50vh;
  color: ${colors.textDefault};
`;
